import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import extraService from '../../services/extra';

const initialState = {
  loading: false,
  extraValues: [],
  meta: {},
  error: '',
};

export const fetchExtraValues = createAsyncThunk(
  'extra/fetchExtraValues',
  (params = {}) => {
    return extraService.getAllValues(params).then((res) => res);
  },
);

const extraValueSlice = createSlice({
  name: 'extraValue',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchExtraValues.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchExtraValues.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.extraValues = Array.isArray(payload?.data) ? payload.data : (payload?.data?.data ?? []);
      state.meta = payload?.meta ?? payload?.pagination ?? {};
      state.error = '';
    });
    builder.addCase(fetchExtraValues.rejected, (state, action) => {
      state.loading = false;
      state.extraValues = [];
      state.meta = {};
      state.error = action.error.message;
    });
  },
});

export default extraValueSlice.reducer;
